import {
  rejectRecurringFile,
  SuccessResponse,
  UpdateRecurringFileResponse,
} from '@back-office/http';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import {
  ResponseMessage,
  STATUS_CODE_NOT_AUTHORIZED,
  STATUS_CODE_REJECT,
  STATUS_CODE_SUCCESS,
} from '../../constants';
import { handleErrorVoidRefund, handleNotAuthorized, Self } from '../common';

function* rejectRecurringFileRequest(
  self: Self,
  id: string[],
  reason: string | undefined
): Generator<Promise<FlowReturn<SuccessResponse>>> {
  self.isLoading = true;
  try {
    const response = yield rejectRecurringFile(id, reason);
    const { status } = (response as UpdateRecurringFileResponse).data;

    if (
      status.code === STATUS_CODE_SUCCESS ||
      status.code === STATUS_CODE_REJECT
    ) {
      return status.code;
    }
    if (status.code === STATUS_CODE_NOT_AUTHORIZED) {
      handleNotAuthorized(self, response as SuccessResponse);
      return Promise.reject(status.code);
    }
    handleErrorVoidRefund(self);
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    return Promise.resolve('Internal server error.');
  } finally {
    self.isLoading = false;
  }
}

export default rejectRecurringFileRequest;
